import { axiosClient, url } from "../../utils/api";
import { Button, Container, Nav, Navbar } from "react-bootstrap";

function NavBaR({ login }: { login?: boolean; logout?: boolean }) {
  return (
    <Navbar bg="dark" data-bs-theme="dark">
      <Container>
        <Navbar.Brand href="#home">Home</Navbar.Brand>
        <Nav className="me-auto">
          <Nav.Link href="/servers">Guilds</Nav.Link>
          <Nav.Link
            target="_blank"
            href="https://discord.com/api/oauth2/authorize?client_id=1121549553624158258&permissions=8&scope=applications.commands%20bot"
          >
            Invite bot
          </Nav.Link>
          {login ? (
            <Nav.Link href={url} className="nav-link">
              Login
            </Nav.Link>
          ) : (
            <Button
              href="/"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                axiosClient
                  .delete("user/logout")
                  .then(() => (window.location.href = "/"));
              }}
            >
              Logout
            </Button>
          )}
        </Nav>
      </Container>
    </Navbar>
  );
}

export default NavBaR;
